/**
 * DOS518 - Digital Operations System for Wildfire Management
 * Copyright (c) 2024-2025 Angelo Irtilaç — All rights reserved.
 *
 * rubricaPersonale.ts
 * Rubrica locale del personale intervenuto — backed su localStorage.
 * Permette l'autocompletamento rapido dei dati operatore nel tab Personale.
 */

import { Qualifica } from '../types';

export interface ContattoPersonale {
  id: string;
  nome: string;
  cognome: string;
  telefono: string;
  radio?: string;
  qualifica: Qualifica;
  ente?: string;
  note?: string;
}

const STORAGE_KEY = 'dos518_rubrica_personale';

export const loadRubricaPersonale = (): ContattoPersonale[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as ContattoPersonale[]) : [];
  } catch {
    return [];
  }
};

export const saveRubricaPersonale = (lista: ContattoPersonale[]): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(lista));
  } catch {
    // Silently ignore storage errors
  }
};

export const aggiungiARubrica = (
  lista: ContattoPersonale[],
  contatto: Omit<ContattoPersonale, 'id'>
): ContattoPersonale[] => {
  // Evita duplicati (stesso nome+cognome, case-insensitive)
  const chiave = `${contatto.nome} ${contatto.cognome}`.trim().toLowerCase();
  const esiste = lista.some(
    (c) => `${c.nome} ${c.cognome}`.trim().toLowerCase() === chiave
  );
  if (esiste) return lista;
  const nuova = [...lista, { ...contatto, id: crypto.randomUUID() }];
  saveRubricaPersonale(nuova);
  return nuova;
};

export const rimuoviDaRubrica = (
  lista: ContattoPersonale[],
  id: string
): ContattoPersonale[] => {
  const nuova = lista.filter((c) => c.id !== id);
  saveRubricaPersonale(nuova);
  return nuova;
};
